import uuid from 'uuid';
import database from '../firebase/firebase';


// ADD_EXPENSE
export const importExpense = (metadata) => ({
    type: 'IMPORT_EXPENSE',
    metadata
});


// const uploadMetaData = {
//     name: file.name,
//     type: file.type,
//     lastModifiedDate: file.LastModified ? file.LastModified : '',
//     url: downloadURL,
//     bucket: bucket,
//     source: 'ba',
//     uid: uid,
//     authUID: authUID,
//     processing: false,
//     processed: false
// }

export const startImportExpense = (importData = {}) => {
    return (dispatch, getState) => {
        const authUID = getState().auth.uid

        // const {
        //     account = '',
        //     accountId = '',
        //     type = '',
        //     url = '',
        //     source = '',
        //     processing = false,
        //     processed = false
        // } = expenseData.data

        // const {
        //     fname = '',
        //     lname = '',
        //     email = '',
        //     bucketUrl = ''
        // } = expenseData

        // source: 'ba',
        // uid: uid,
        // authUID: authUID,
        // processing: false,
        // processed: false,

        const {
            name = '',
            type = '',
            bucket = '',
            bucketUrl = '',
            uploadDate = 0,
            source = '',
            uid = '',
            processing = false,
            processed = false
        } = importData


        const metadata = {
            name,
            type,
            bucket,
            bucketUrl,
            uploadDate,
            source,
            uid,
            processing,
            processed
        };

        console.log("metadata: ", metadata)
        return database.ref(`users/${authUID}/imports`).push(metadata).then((ref) => {
            dispatch(importExpense({
                id: ref.key,
                ...metadata
            }));
        });
    };
};





// WEBPACK FOOTER //
// ./src/actions/imports.js